import type React from 'react';

/**
 * WEB-1805 (живой случай Д48) — ОДНА запись вторичного стиля портальных кнопок.
 *
 * ЗАЧЕМ ОДНА. Прозрачная кнопка портала («Возобновить подписку», «Отменить
 * подписку» и её шаги) стояла ДВУМЯ одинаковыми копиями — по копии в каждом
 * файле. 18.09 на экране оплаты с фоновой картинкой кнопка возобновления вышла
 * тёмным текстом на тёмном фоне: человек не видит кнопку, и это кнопка про то,
 * чтобы он продолжил платить. Починить одну копию и оставить вторую — ровно тот
 * класс дефекта, из-за которого в репе заведено правило «у правила два конца»
 * (WEB-1844). Здесь второго конца больше нет ПО ПОСТРОЕНИЮ: запись одна,
 * сторожить нечего.
 *
 * ПОЧЕМУ ЦВЕТ — ПЕРЕМЕННАЯ. Кнопка прозрачная, то есть её надпись лежит прямо
 * на экране. Экран с тёмной вуалью над фото или с тёмной собственной заливкой
 * прикалывает себе светлый текст переменной `--color-text-primary`
 * (`ScreenBackgroundWrapper`, `LIGHT_TEXT_PIN`). Прежний голый `inherit` до
 * этой переменной не доходил и оставлял надпись цветом светлой темы. Фолбэк
 * `inherit` сохраняет прежний вид везде, где переменная не задана, — вид
 * выкаченных воронок не меняется ни на байт.
 */
export const PORTAL_GHOST_BUTTON_STYLE: React.CSSProperties = {
  display: 'block',
  width: '100%',
  padding: '10px 16px',
  borderRadius: 8,
  border: '1px solid #d9d9d9',
  background: 'transparent',
  color: 'var(--color-text-primary, inherit)',
  cursor: 'pointer',
  fontSize: 14,
};
